import { Tag as _Tag } from 'antd5';
import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const Tag = styled(_Tag)`
  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          background: ${theme.activeMenuItemBackgroundColor};
          border-color: ${theme.tertiaryBackgroundColor};
          color: ${theme.secondaryTextColor};
        `
      : ''}
`;
